import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_76: FaireProductEntity = {
  token: "catalog_prod_prod-76",
  type: "product",
  name: "Decorative Item B",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 69.99,
  msrpDollars: 174.98,
  sku: "AN0076",
  caseSize: 6,
  material: "Ceramic",
  collectionToken: "col_andean-touch",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 149,
  description: "Beautiful Andean Touch piece perfect for any home.",
  categoryTokens: ["catalog_cat_home-fragrances"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
